// package imports
import { KitCard, KitCardBody } from 'components/common/cms-kit';
import { useTheme } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import { Box, Checkbox, FormControl, FormControlLabel, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';

// local imports
import { useObservationStore } from '../stores/observationStore';
import { ObsStyles } from './StyledComponents';

const SessionChecklists = ({ eventState, eventStateOnChange }) => {
  const theme = useTheme();
  const styles = ObsStyles(theme);
  const isReadonly = !eventStateOnChange;

  const { observation } = useObservationStore();

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: '1rem' }}>
      <KitCard>
        <KitCardBody style={{ marginTop: '1rem', marginBottom: '1rem' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '.2rem' }}>
            <Typography sx={{ fontSize: '24px', fontWeight: 600, lineHeight: '30px', color: theme.palette.primary.dark, mb: '1rem' }}>
              Physical Environment Checklist
            </Typography>
            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.skills_posters}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('skills_posters', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='BT Skills Posters'
            />

            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.classroom_rules}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('classroom_rules', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='Classroom Rules'
            />

            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.schoolwide_rules}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('schoolwide_rules', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='School-wide Rules'
            />

            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.classroom_procedures}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('classroom_procedures', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='Classroom Procedures'
            />

            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.schoolwide_procedures}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('schoolwide_procedures', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='School-wide Procedures'
            />

            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.consequences}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('consequences', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='Consequences'
            />

            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.daily_schedule}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('daily_schedule', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='Daily schedule/agenda'
            />

            {observation && observation.classroom_type === 'Specialized Classroom Management' && (
              <>
                <FormControlLabel
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  control={
                    <Checkbox
                      sx={[isReadonly ? {
                        cursor: 'default'
                      } : {
                        cursor: 'pointer'
                      }]}
                      checked={eventState.cards_on_desk}
                      onChange={(e) => eventStateOnChange && eventStateOnChange('cards_on_desk', e.target.checked)}
                      color='gold'
                      checkedIcon={<CheckCircleIcon />}
                      icon={<CheckCircleOutlineIcon color='gold' />}
                    />
                  }
                  label='Cards on desk'
                />
                <FormControlLabel
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  control={
                    <Checkbox
                      sx={[isReadonly ? {
                        cursor: 'default'
                      } : {
                        cursor: 'pointer'
                      }]}
                      checked={eventState.students_write_cards}
                      onChange={(e) => eventStateOnChange && eventStateOnChange('students_write_cards', e.target.checked)}
                      color='gold'
                      checkedIcon={<CheckCircleIcon />}
                      icon={<CheckCircleOutlineIcon color='gold' />}
                    />
                  }
                  label='Students write on their cards'
                />
              </>
            )}

            <FormControl fullWidth size='small'>
              <TextField
                placeholder='Enter notes here...'
                multiline={true}
                rows={4}
                sx={{ ...styles.select, marginTop: '.75rem' }}
                label='Physical Environment Notes'
                id='phys-env-notes'
                error={eventState.phys_env_notesError}
                size='small'
                value={eventState.phys_env_notes}
                onChange={(e) => {
                  eventStateOnChange && eventStateOnChange('phys_env_notes', e.target.value);
                }}
                slotProps={{
                  input: { sx: { ...styles.select } },
                  htmlInput: { maxLength: 500, readOnly: isReadonly, style: { cursor: isReadonly ? 'default' : 'pointer' } },
                  inputLabel: { shrink: true }
                }} />
            </FormControl>
          </Box>
        </KitCardBody>
      </KitCard>
      <KitCard>
        <KitCardBody style={{ marginTop: '1rem', marginBottom: '1rem' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', rowGap: '.2rem', height: '100%' }}>
            <Typography sx={{ fontSize: '24px', fontWeight: 600, lineHeight: '30px', color: theme.palette.primary.dark, mb: '1rem' }}>
              Relationship Building Checklist
            </Typography>

            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.atsmosphere}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('atsmosphere', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='Creates a welcoming and engaging atmosphere in the classroom'
            />

            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.solicits}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('solicits', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='Solicits student input, opinions, and feedback'
            />

            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.positive_comments}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('positive_comments', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='Makes positive, encouraging comments to students and recognizes accomplishments'
            />

            <FormControlLabel
              sx={[isReadonly ? {
                cursor: 'default'
              } : {
                cursor: 'pointer'
              }]}
              control={
                <Checkbox
                  sx={[isReadonly ? {
                    cursor: 'default'
                  } : {
                    cursor: 'pointer'
                  }]}
                  checked={eventState.quality_components}
                  onChange={(e) => eventStateOnChange && eventStateOnChange('quality_components', e.target.checked)}
                  color='gold'
                  checkedIcon={<CheckCircleIcon />}
                  icon={<CheckCircleOutlineIcon color='gold' />}
                />
              }
              label='Uses positive quality and relational components (ex. voice tone, physical proximity, gestures, facial expressions, use student name/term of endearment, humor)'
            />

            <FormControl fullWidth size='small' sx={{ alignSelf: 'flex-end' }}>
              <TextField
                placeholder='Enter notes here...'
                multiline={true}
                rows={4}
                sx={{ ...styles.select, marginTop: '.75rem' }}
                label='Relationship Building Notes'
                id='rel-bld-notes'
                error={eventState.rel_bld_notesError}
                size='small'
                value={eventState.rel_bld_notes}
                onChange={(e) => {
                  eventStateOnChange && eventStateOnChange('rel_bld_notes', e.target.value);
                }}
                slotProps={{
                  input: { sx: { ...styles.select } },
                  htmlInput: { maxLength: 500, readOnly: isReadonly, style: { cursor: isReadonly ? 'default' : 'pointer' } },
                  inputLabel: { shrink: true }
                }} />
            </FormControl>
          </Box>
        </KitCardBody>
      </KitCard>
    </Box>
  );
};

SessionChecklists.propTypes = {
  eventState: PropTypes.object.isRequired,
  eventStateOnChange: PropTypes.func,
};

export default SessionChecklists;
